import React from 'react';
import clx from "classnames";
import { FiCheck, FiMoreHorizontal,  FiUsers, FiVolume2 } from 'react-icons/fi'
import {FaThumbtack} from 'react-icons/fa'
import { supportGroups, users } from '../../../../dummy/users';
import supportStore from '../../../../stores/useSupport';

const Users = () => {
    const [selected, setSelected] = React.useState(1);
    const {setConversation, primaryColor, detail} = supportStore(state=>state)
  
    return (
       
      <ul>
      {supportGroups.map((item,i)=>(
             <li
              onClick={()=>{
                setSelected(item.id)
                setConversation(i)
              }}
             >
             <div
              className={clx(
                item.id==selected ? `dark:bg-zinc-700 bg-${primaryColor}-200` : 'dark:hover:bg-zinc-700 hover:bg-gray-200',
                'flex justify-between  p-3 dark:border-black/30 border-b cursor-pointer'
              )}
             >
               <div class="flex gap-2">
                <div class="">
                   <div class="w-12 h-12 bg-gray-300 dark:bg-zinc-700 rounded-md relative">
                     <img src={`/images/frameworks/${item.brand}.png`} class="h-6 w-6 object-contain absolute right-0 bottom-0 " />
                   </div>
                </div>
                 <div>
                   <div class="flex items-center">
                     <div class="font-medium text-zinc-800  dark:text-white" > {detail ? item.title.slice(0,17)+'..' : item.title} </div>
                   </div>
                   <p class="text-sm text-gray-500">
                     You might miss this last week
                   </p>
                 </div>
               </div>
               
               {!item.count && (
                <div class="date flex items-center">
                <div class="readed -mr-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check text-green-500 h-3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check text-green-500 h-3 -mt-2"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                <p class="text-xs text-gray-500">18:20</p>
              </div>
               )}
           
              {item.count && (
                 <div 
                 class="flex items-end flex-col gap-1">
                   <div class="date flex">
                     <div class="readed -mr-1">
                       <FiCheck size={23} class="text-gray-500 h-3" /> 
                       <FiCheck size={23}
                         class="text-gray-500 h-3 -mt-2"
                       /> 
                     </div>
                     <p class="text-xs text-gray-500">18:20</p>
                   </div>
                    <div
                      class="badge w-4 h-4 text-xs flex items-center justify-center rounded-full bg-blue-500 text-white font-bold"
                      > {item.count}
                    </div>
                 </div>
              )}
             </div>
           </li>
      ))}
  </ul>
    )
}

export default Users;